module.exports = __webpack_public_path__ + "img/comment-xmark.a51b3a73.svg";